"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransactionCode = void 0;
var TransactionCode;
(function (TransactionCode) {
    TransactionCode["MatchEntryFee"] = "MATCH_ENTRY_FEE";
    TransactionCode["MatchEntryPlatformFee"] = "MATCH_ENTRY_PLATFORM_FEE";
    TransactionCode["MatchWithdrawal"] = "MATCH_WITHDRAWAL";
    TransactionCode["MatchPlatformFeeWithdrawal"] = "MATCH_PLATFORM_FEE_WITHDRAWAL";
    TransactionCode["MatchWin"] = "MATCH_WIN";
    TransactionCode["MatchPlatformFee"] = "MATCH_PLATFORM_FEE";
    TransactionCode["MatchPrizesDistributionRemainder"] = "MATCH_PRIZES_DISTRIBUTION_REMAINDER";
    TransactionCode["TournamentSeed"] = "TOURNAMENT_SEED";
    TransactionCode["TournamentSeedWithdrawal"] = "TOURNAMENT_SEED_WITHDRAWAL";
    TransactionCode["TournamentSeedPlatformFee"] = "TOURNAMENT_SEED_PLATFORM_FEE";
    TransactionCode["TournamentSeedPlatformFeeWithdrawal"] = "TOURNAMENT_SEED_PLATFORM_FEE_WITHDRAWAL";
    TransactionCode["TournamentEntryFee"] = "TOURNAMENT_ENTRY_FEE";
    TransactionCode["TournamentEntryFeeWithdrawal"] = "TOURNAMENT_ENTRY_FEE_WITHDRAWAL";
    TransactionCode["TournamentEntryPlatformFee"] = "TOURNAMENT_ENTRY_PLATFORM_FEE";
    TransactionCode["TournamentEntryPlatformFeeWithdrawal"] = "TOURNAMENT_ENTRY_PLATFORM_FEE_WITHDRAWAL";
    TransactionCode["TournamentEntryFeeFromReward"] = "TOURNAMENT_ENTRY_FEE_FROM_REWARD";
    TransactionCode["TournamentEntryFeeWithdrawalToReward"] = "TOURNAMENT_ENTRY_FEE_WITHDRAWAL_TO_REWARD";
    TransactionCode["TournamentWin"] = "TOURNAMENT_WIN";
    TransactionCode["TournamentPrizesExternal"] = "TOURNAMENT_PRIZES_EXTERNAL";
    TransactionCode["TournamentPrizesDistributionRemainder"] = "TOURNAMENT_PRIZES_DISTRIBUTION_REMAINDER";
    TransactionCode["TournamentOrganizerFee"] = "TOURNAMENT_ORGANIZER_FEE";
    TransactionCode["TournamentPlatformFee"] = "TOURNAMENT_PLATFORM_FEE";
    TransactionCode["BalanceReplenishment"] = "BALANCE_REPLENISHMENT";
    TransactionCode["BalanceWithdrawal"] = "BALANCE_WITHDRAWAL";
    TransactionCode["BalanceWithdrawalCancel"] = "BALANCE_WITHDRAWAL_CANCEL";
    TransactionCode["BalanceWithdrawalFee"] = "BALANCE_WITHDRAWAL_FEE";
    TransactionCode["BalanceInternalTransfer"] = "BALANCE_INTERNAL_TRANSFER";
    TransactionCode["PaypalWithdrawal"] = "PAYPAL_WITHDRAWAL";
    TransactionCode["PaypalWithdrawalFee"] = "PAYPAL_WITHDRAWAL_FEE";
    TransactionCode["PaypalWithdrawalRejection"] = "PAYPAL_WITHDRAWAL_REJECTION";
    TransactionCode["PaypalWithdrawalFeeRejection"] = "PAYPAL_WITHDRAWAL_FEE_REJECTION";
    TransactionCode["SwapBuy"] = "SWAP_BUY";
    TransactionCode["SwapSell"] = "SWAP_SELL";
    TransactionCode["SwapFee"] = "SWAP_FEE";
    TransactionCode["AffiliateProgramRegistrationReward"] = "AFFILIATE_PROGRAM_REGISTRATION_REWARD";
    TransactionCode["AffiliateProgramCommissionPayout"] = "AFFILIATE_PROGRAM_COMMISSION_PAYOUT";
    TransactionCode["AffiliateProgramReturnRewardBalance"] = "AFFILIATE_PROGRAM_RETURN_REWARD_BALANCE";
})(TransactionCode = exports.TransactionCode || (exports.TransactionCode = {}));
//# sourceMappingURL=transaction-code.js.map